import styled, {css} from 'styled-components/native';

import {RFValue} from 'react-native-responsive-fontsize';

import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import { Platform} from 'react-native';
import FastImage from 'react-native-fast-image';

export const Container = styled.View`
  padding: 0 24px;
  padding-bottom: ${RFValue(20)}px;

  z-index: 2;
`;

export const Column = styled.View`
  align-items: center;
`;

export const Row = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${RFValue(6)}px;
`;

export const HeaderButton = styled.View`
  align-items: center;
`;
export const HeaderIcon = styled(FontAwesome)`
  font-size: ${RFValue(22)}px;
  color: ${({theme}) => theme.colors.title};
`;
export const HeaderButtonLabel = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(8.5)}px;
`;

// Chip com ícone + label — variante sólida (fundo verde, texto branco)
export const ActionChipSolid = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: ${RFValue(36)}px;
  background-color: rgba(23, 183, 15, 1);
  padding-right: ${RFValue(10)}px;
`;

// Chip com ícone + label — variante ghost (fundo transparente, texto verde)
export const ActionChipGhost = styled(ActionChipSolid)`
  background-color: ${({theme}) => theme.colors.background};
`;

// Botão circular só com ícone (perfil)
export const ProfileButton = styled.TouchableOpacity`
  height: ${RFValue(32)}px;
  width: ${RFValue(32)}px;
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.profile_background};
  justify-content: center;
  align-items: center;
`;

export const ChipIconBox = styled.View`
  height: ${RFValue(28)}px;
  width: ${RFValue(28)}px;
  justify-content: center;
  align-items: center;
`;

export const ProfileInitials = styled.Text`
  color: ${({theme}) => theme.colors.profile_initials};
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
`;

// Ícone para chip sólido (branco)
export const ChipIconSolid = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(16)}px;
`;

// Ícone para chip ghost (verde)
export const ChipIconGhost = styled(FontAwesome5)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(13)}px;
`;

// Label para chip sólido (branco)
export const ChipLabelSolid = styled.Text`
  color: #fff;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

// Label para chip ghost (verde)
export const ChipLabelGhost = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const ChipArrow = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.shape};
  margin-left: ${RFValue(4)}px;
`;

export const SearchContainer = styled.View`
  background-color: rgba(255, 255, 255, 1);

  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: ${RFValue(20)}px;
  height: ${RFValue(30)}px;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${RFValue(12)}px;
  flex-direction: row;
`;

export const SearchInput = styled.TextInput`
  height: ${RFValue(30)}px;
  flex: 1;
  padding: 0 ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const SearchIcon = styled(FontAwesome5)`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  color: rgba(0, 0, 0, 0.6);
`;

export const AccountBalance = styled.View`
  padding: ${RFValue(12)}px 0;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${RFValue(16)}px;
  margin-bottom: ${RFValue(4)}px;
`;

export const AccountBalanceButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1;

`;

export const AccountBalanceColumn = styled.View``;
export const AccountBalanceTitle = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.shape};
    line-height: ${RFValue(12)}px;
    margin-top: ${RFValue(4)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;


export const AccountBalanceDivider = styled.View`
  width: 1px;
  height: ${RFValue(24)}px;
  background-color: rgba(255,255,255,0.4);
`;

export const PeopleIcon = styled(FontAwesome5)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const AccountBalanceRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}px;
`;

export const AccountBalanceValue = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.shape};

  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const AccountBalanceArrow = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const AccountMenus = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin: 0 6px;
  margin-bottom: ${RFValue(10)}px;
  gap: ${RFValue(12)}px;
`;
export const AccountMenuItem = styled.View`
  flex-direction: column;
  align-items: center;
  gap: ${RFValue(2)}px;
`;
export const AccountMenuIcon = styled(FontAwesome5)`
  font-size: ${RFValue(16)}px;
  color: #15a118;
`;
export const AccountMenuTitle = styled.Text`
  text-align: center;
  font-size: ${RFValue(8.5)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const AccountIconBox = styled.View`
  width: ${RFValue(36)};
  height: ${RFValue(36)}px;
  background-color: rgba(23, 183, 15, 0.2);
  border-radius: ${RFValue(22)}px;
  justify-content: center;
  align-items: center;
`;

export const CurrentLevelContainer = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;

  ${({theme}) =>
    Platform.OS === 'ios'
      ? css`
          shadow-color: ${theme.colors.blue};
          shadow-offset: 0px 4px;
          shadow-opacity: 0.15;
          shadow-radius: 4px;
        `
      : css`
          elevation: 1;
        `}
`;

export const CurrentCarBadge = styled.View`
  width: ${RFValue(40)}px;
  height: ${RFValue(40)}px;
  border-radius: ${RFValue(24)}px;

  align-items: center;
  justify-content: center;

  z-index: 20;
`;

export const CurrentCarLevel = styled.View`
  border-radius: ${RFValue(24)}px;

  background-color: rgba(255, 149, 0, 1);
  align-items: center;
  justify-content: center;

  padding: ${RFValue(4)}px ${RFValue(8)}px;
  padding-right: ${RFValue(30)}px;
  margin-right: -${RFValue(23)};
  z-index: 10;
`;
export const CurrentCarLevelText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: #fff;

  font-size: ${RFValue(10)}px;
`;


export const IndicationContainer = styled.View`
  background-color: rgba(252, 233, 255, 1);
  height: ${RFValue(28)}px;
  width: 100%;
  border-radius: ${RFValue(30)}px;
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(12)}px;
  flex-direction: row;
  gap:${RFValue(3)}px;
`;

export const IndicationText = styled.Text`
  color: rgba(195, 48, 255, 1);
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const IndicationImage = styled(FastImage)`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
`;
